import { Injectable } from '@angular/core';
import {EnvironmentService} from './environment-service';

@Injectable({ providedIn: 'root' })
export class JiraHelperService {
  private jiraKeyPrefix: string;
  private jiraBaseUrl: string;
  private serviceDeskId: string;
  private regex: RegExp;

  constructor(private environmentService: EnvironmentService) {
    this.jiraKeyPrefix = environmentService.getJiraApiKeyPrefix();
    this.jiraBaseUrl = environmentService.getJiraApiBaseUr();
    this.serviceDeskId = environmentService.getJiraApiServiceDeskId();
    this.regex = new RegExp(`\\b${this.jiraKeyPrefix}-\\d+\\b`, 'g');
  }
  getIssueUrl(jiraKey: string, isExternalPortal: boolean): string {
    return isExternalPortal ? `${this.jiraBaseUrl}/servicedesk/customer/portal/${this.serviceDeskId}/${jiraKey}` : `${this.jiraBaseUrl}/browse/${jiraKey}`;
  }

  containsIssueKey(text: string): boolean {
    if (text == null) { return false; }
    return this.regex.test(text);
  }
  extractIssueKey(text: string): string | null {
    if (text == null) { return null; }
    const match = text.match(this.regex);
    return match ? match[0] : null;
  }
}
